import keycloakStore from "@/businesslogic/stores/keycloakStore";
import axios from "axios";
import Logger from "js-logger";
import { Anfrage } from "@/model/Anfrage";

class AdressenDatenService {
  http() {
    const keycloakAccessToken = keycloakStore().getKeycloakAccessToken();

    let headers;
    if (keycloakAccessToken) {
      headers = {
        Authorization: "Bearer " + keycloakAccessToken,
        "Content-Type": "application/json",
      };
    }

    return axios.create({
      baseURL: process.env.VUE_APP_BACKEND_URL,
      timeout: process.env.VUE_APP_BACKEND_TIMEOUT,
      headers: headers,
    });
  }

  plzValidieren(sessionId: string, iPlz: any) {
    return this.http()
      .post("/api/adresse/postCodeAutocomplete", {
        sessionId: sessionId,
        adresse: {
          plz: iPlz,
        },
      })
      .then((antwort: any) => {
        Logger.debug("Antwort plzValidieren extern:", antwort.data.plzKorrekt);
        return antwort.data.plzKorrekt;
      })
      .catch((fehler) => {
        Logger.debug("Externe PLZ-Validierung schlug fehl:", fehler);
        // Auf interne Schnittstelle ausweichen, um Wechsel auf Schritt 2 zu ermöglichen
        return this.http()
          .get("/api/plz/" + iPlz)
          .then((antwort: any) => {
            Logger.debug("Antwort plzValidieren intern:", antwort.data);
            return antwort.data;
          })
          .catch((fehler) => {
            Logger.debug("Interne PLZ-Validierung schlug ebenfalls fehl:", fehler);
          });
      });
  }

  vorschlagen(sessionId: string, iPlz: any, iOrt: any, iStrasse: any, url: string) {
    return this.http()
      .post("/api/adresse" + url, {
        sessionId: sessionId,
        adresse: {
          plz: iPlz,
          ort: iOrt,
          strasse: iStrasse,
        },
      })
      .then((antwort: any) => {
        return antwort.data;
      });
  }

  pruefen(sessionId: string, iPlz: any, iOrt: any, iStrasse: any, iHausnummer: any) {
    return this.http()
      .post("/api/adresse/addressCheck", {
        sessionId: sessionId,
        adresse: {
          plz: iPlz,
          ort: iOrt,
          strasse: iStrasse,
          hausnummer: iHausnummer,
        },
      })
      .then((antwort: any) => {
        Logger.debug("antwort pruefen", antwort);
        return antwort;
      });
  }

  denkmalschutzErmitteln(iAnfrage: Anfrage) {
    return this.http()
      .post("/api/addressresolve/vorbelegungDenkmalschutzErmitteln", this.preProcess(iAnfrage))
      .then((antwort: any) => {
        return antwort;
      })
      .catch((fehler) => {
        Logger.debug("Denkmalschutz-Vorbelegung schlug fehl:", fehler);
      });
  }

  preProcess(anfrage: Anfrage) {
    const obj = JSON.parse(JSON.stringify(anfrage));
    obj.zahlungsdaten.iban = obj.zahlungsdaten.iban.replace(/ /g, "");
    return obj;
  }
}

export default new AdressenDatenService();
